import React from "react";
import {
  Sparkles, SprayCan, Truck, DoorOpen, HardHat, BedDouble, Building2,
} from "lucide-react";

// Canonical service value → icon. Labels come from the same filtered
// SERVICE_TYPES list the quote dropdown uses (passed in as `services`),
// so this section and the dropdown always show the identical service set.
const SERVICE_ICONS = {
  "Standard Clean": Sparkles,
  "Deep Clean": SprayCan,
  "Move-Out": Truck,
  "Move-In": DoorOpen,
  "Post-Construction": HardHat,
  "Airbnb Turnover": BedDouble,
  "Office / Commercial": Building2,
};

// Public "Services" marketing section. `services` is the already-filtered
// availableServiceTypes array ({value,en,es}) from PublicLeadForm — no
// second configuration or translation source.
export const PublicBusinessServices = ({ services, lang, t }) => {
  const list = (services || []).filter((s) => s && s.value);
  if (list.length === 0) return null;
  return (
    <section
      className="bg-white rounded-2xl border border-gray-200 p-6 sm:p-10 lg:p-14 mb-5 lg:mb-8"
      data-testid="public-services-section"
    >
      <span className="block w-10 h-1 rounded-full bg-green-700 mb-3" aria-hidden="true" />
      <h2 className="font-display text-xl sm:text-2xl lg:text-3xl font-semibold text-gray-900 tracking-tight">
        {t("public.services.title")}
      </h2>
      <p className="mt-2 text-sm lg:text-base text-gray-500">{t("public.services.subtitle")}</p>
      <div className="mt-4 lg:mt-8 grid grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-2.5 lg:gap-4">
        {list.map((svc) => {
          const Icon = SERVICE_ICONS[svc.value] || Sparkles;
          return (
            <div
              key={svc.value}
              className="flex items-center gap-2 sm:gap-2.5 lg:gap-3.5 px-2.5 py-2 sm:px-3.5 sm:py-3 lg:px-5 lg:py-4 rounded-lg lg:rounded-xl border border-gray-200 bg-gray-50/70 hover:border-green-300 hover:bg-green-50/60 transition-colors"
              data-testid={`public-service-${svc.value.replace(/[^a-zA-Z]+/g, "-").toLowerCase()}`}
            >
              <span className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10 rounded-md lg:rounded-lg bg-white border border-green-100 flex items-center justify-center shrink-0">
                <Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 lg:w-5 lg:h-5 text-green-800" />
              </span>
              <span className="min-w-0 break-words text-xs sm:text-sm lg:text-[15px] font-medium leading-snug text-gray-800">
                {svc[lang] || svc.en}
              </span>
            </div>
          );
        })}
      </div>
    </section>
  );
};
